import { render, staticRenderFns } from "./EditLinks.vue?vue&type=template&id=3a71de60&scoped=true&"
import script from "./EditLinks.vue?vue&type=script&lang=js&"
export * from "./EditLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71de60",
  null
  
)

export default component.exports